
const appendUrlParams = (url, params) => {
  if (!url || !params) {
    return url;
  }

  const resultUrl = new URL(url);

  for (const [param, value] of Object.entries(params)) {
    resultUrl.searchParams.append(param, value);
  }

  return resultUrl.toString();
};

export default appendUrlParams;
